import * as ActionTypes from '../actions';
import * as UserTypes from '../actions/users';
import { camelCase, isEmpty, map, split } from 'lodash';

const defaultState = () => {
  return {
    authExpires: localStorage.getItem('auth:authExpires'),
    bgColor: localStorage.getItem('auth:bgColor'),
    id: localStorage.getItem('auth:id') || -1,
    isAuthenticated: !isEmpty(localStorage.getItem(ActionTypes.AUTH_TOKEN)),
    isAuthChecked: false,
    isAuthReset: false,
    logoUrl: localStorage.getItem('auth:logoUrl'),
    name: localStorage.getItem('auth:name'),
    options: split(localStorage.getItem('auth:options'), ','),
    features: localStorageFeatures(),
    role: localStorage.getItem('auth:role'),
    partnerId: localStorage.getItem('auth:partnerId'),
  }
};

const localStorageFeatures = function () {
  const storedValue = localStorage.getItem('auth:features');

  if (storedValue) {
    return JSON.parse(storedValue);
  }
}

export default function auth(state = defaultState(), action) {
  switch (action.type) {
    case ActionTypes.AUTH_RECEIVE:
      action.payload.data['options'] = map(action.payload.data['options'], opt => camelCase(opt));
      window.auth_session_token = action.payload.headers.map.authorization;
      localStorage.setItem(ActionTypes.AUTH_TOKEN, window.auth_session_token);
      Object.keys(action.payload.data).forEach(key => {
        if (key === 'features') {
          const value = JSON.stringify(action.payload.data['features']);
          localStorage.setItem(`auth:${key}`, value);
        } else {
          localStorage.setItem(`auth:${key}`, action.payload.data[key] || '');
        }
      });
      return { ...state, ...{ ...action.payload.data, isAuthenticated: true, isAuthChecked: true } };
    case ActionTypes.AUTH_REFRESH_RECEIVE: {
      action.payload.data['options'] = map(action.payload.data['options'], opt => camelCase(opt));
      Object.keys(action.payload.data).forEach(key => {
        if (key === 'features') {
          const value = JSON.stringify(action.payload.data['features']);
          localStorage.setItem(`auth:${key}`, value);
        } else {
          localStorage.setItem(`auth:${key}`, action.payload.data[key] || '');
        }
      });
      return { ...state, ...{ ...action.payload.data, isAuthenticated: true, isAuthChecked: true } };
    }
    case UserTypes.ADMIN_USER_RESET_PASSWORD_RECEIVE:
    case UserTypes.ADMIN_USER_CHANGE_PASSWORD_RECEIVE:
      return { ...state, isAuthReset: true };
    default:
      if (!state.isAuthChecked && /_RECEIVE$/.test(action.type)) return { ...state, isAuthChecked: true, isAuthReset: false };
      return { ...state, isAuthReset: false };
  }
}
